"use client";

/**
 * One delegated click listener for the server-rendered SEO pages: any
 * element carrying `data-track="event.name"` (and optional
 * `data-track-props='{"k":"v"}'`) fires that first-party event when
 * clicked. The links stay server components; the page ships one tiny
 * effect instead of a client wrapper per link.
 */
import { useEffect } from "react";
import { trackEvent } from "@/lib/tracking";

export default function ClickTracker() {
  useEffect(() => {
    function onClick(e: MouseEvent) {
      const el = (e.target as Element | null)?.closest?.("[data-track]") as HTMLElement | null;
      const name = el?.dataset.track;
      if (!el || !name) return;
      let props: Record<string, unknown> = {};
      try { props = el.dataset.trackProps ? JSON.parse(el.dataset.trackProps) : {}; } catch { /* malformed: send the name alone */ }
      trackEvent(name, props);
    }
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);
  return null;
}
